import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import './styles/base.css';
import App from './App.jsx';
import { ThemeProvider } from './lib/theme.jsx';
import { TrackProvider } from './lib/track.jsx';
import { ProgressProvider } from './lib/progress.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <TrackProvider>
        <ProgressProvider>
          <App />
        </ProgressProvider>
      </TrackProvider>
    </ThemeProvider>
  </StrictMode>
);
